import { styled } from '@mui/material'

export const ProgressWrapper = styled('div')(() => ({
  // display: "grid",
  gap: '12px',
}))

export const ProgressContent = styled('div')(({ theme }) => ({
  display: 'grid',
  gridTemplateColumns: '1fr 500px',
  gap: '12px',
  [theme.breakpoints.down('lg')]: {
    gridTemplateColumns: '1fr',
  },
}))

export const ProgressLeft = styled('div')(() => ({
  display: 'grid',
  gap: '14px',
  alignContent: 'flex-start',
  alignItems: 'flex-start',
}))

export const ProgressRight = styled('div')(() => ({
  display: 'grid',
  gap: '14px',
  alignContent: 'flex-start',
  alignItems: 'flex-start',
}))

export const LeadershipValueTable = styled('table')(({ theme }) => ({
  width: '100%',
  'td,th': {
    padding: '12px',
    font: '400 12px Poppins, sans-serif',
    textAlign: 'center',
  },
  'th:not(:first-of-type),td:not(:first-of-type)': {
    fontWeight: '600',
    width: '70px',
  },
  thead: {
    background: '#F2F4F5',
    th: {
      color: theme.palette.primary.main,
      font: '600 16px Poppins, sans-serif',
      [theme.breakpoints.down('md')]: {
        fontSize: '12px !important',
      },
    },
    'th:first-of-type': {
      borderRadius: '12px 0 0 12px',
    },
    'th:last-of-type': {
      borderRadius: '0 12px 12px 0',
    },
  },
}))
